export const blue = '#30589d';
